import React from "react";
import {connect} from 'react-redux'

const FoldingParagraph = ({title, children, closed}) => {
    const _title = title || ''
    const _closed = !closed

    const [detail, setDetail] = React.useState(_closed);

    return (
        <div style={{
            margin: 12,
            cursor: 'default',
            userSelect: 'none',
        }}>
            <div style={{
                fontWeight: 'bold',
                marginBottom: 7,
                fontSize: 15,
                cursor: 'pointer',
            }}
            onClick={() => setDetail(!detail)}>

                <span>{!detail && "+ "}{_title}</span>

            </div>
            {detail && <div>
                {children}
            </div>}
        </div>
    )
}

function mapStateToProps(state, other) {
    return {state}
}

export default connect(mapStateToProps)(FoldingParagraph)
